import { Routes } from '@angular/router';
import { DashbordComponent } from './pages/dashbord/dashbord.component';
import { TransactionListComponent } from './pages/transaction-list/transaction-list.component';
import { TransactionDetailsComponent } from './pages/transaction-details/transaction-details.component';

export const routes: Routes = [
    { path: '', component: DashbordComponent },
    { path: 'transaction', component: TransactionListComponent },
    { path: 'dashboard', component: DashbordComponent },
    { path: 'transactionDetails', component: TransactionDetailsComponent }
    

];
